import { render, staticRenderFns } from "./function.vue?vue&type=template&id=ddb8064a"
import script from "./function.vue?vue&type=script&lang=js"
export * from "./function.vue?vue&type=script&lang=js"
import style0 from "./function.vue?vue&type=style&index=0&id=ddb8064a&prod&lang=scss"
import style1 from "./function.vue?vue&type=style&index=1&id=ddb8064a&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports